export const environment = {
  production: false,
  url: "https://crm-api-cd.policystreet.app"
};
